module.exports = __webpack_public_path__ + "static/img/default.0bc4253.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.jpeg
// module id = 64Ec
// module chunks = 1